import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import PageLoading from "../../components/PageLoading.jsx";
import OurLocation from "./OurLocation.jsx";

import * as API from "../../api/api.js";

const PalmBeachCounty = ({settings}) => {
  const [loading, setLoading] = useState(false);
  const [palm, setPlam] = useState([]);

  useEffect(() => {
    setPalmData();
  }, []);

  const setPalmData = () => {
    setLoading(true);
    API.getDatas("city/palm-beach")
      .then((res) => {
        const lIndex = res.data.findIndex(f => f.slug === 'palm-beach');
        if (lIndex != -1) {
          setPlam(res.data[lIndex].locations);
          document.title = `Metro Traffic School - ${res.data[lIndex].name}`;
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <>
      <section className="inner-page notranslate d-flex align-items-center justify-content-center">
        <div className="overlay"></div>
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xl-12">
              <nav aria-label="breadcrumb">
                <h4 className="main-heading text-capitalize text-center mb-0">
                  Locations
                </h4>
                <ol className="breadcrumb d-flex align-items-center justify-content-center">
                  <li className="breadcrumb-item">
                    <Link to="/" className="text-white" href>
                      Home
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link className="text-white" href>
                      Locations
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Palm Beach County
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>

      <section className="location-section section-padding">
        <div className="container">
          <div className="row">
            <OurLocation settings={settings} />
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 location-accordion">
              <div className="row">
                <div className="col-12">
                  <h3 className="text-white">Palm Beach County</h3>
                  <div className="accordion-body col-12">
                    <div className="row">
                      {!loading &&
                        palm &&
                        palm.map((palmdata, pIndex) => (
                          <div
                            key={pIndex}
                            className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-4 mb-4 mb-md-5  d-flex justify-content-between flex-column"
                          >
                            <div className="address">
                              <h3>{palmdata.title}</h3>
                              <div className="address-detail mb-3">
                                {palmdata.address.split(',')[0]}<br/>
                                  {`${palmdata.address.split(',')[1]}, ${palmdata.address.split(',')[2]}`} <br />
                                <a href="tel:(561) 963-7555 ">
                                  Phone: &nbsp;{palmdata.phone} <br />
                                </a>
                                {palmdata?.fax && (
                                  <p>Fax: &nbsp;{palmdata.fax}</p>
                                )}
                                <br />
                              </div>
                            </div>
                            <div className="location-btns">
                              <Link
                                to="/contact-us"
                                className="btn contact-us-btn contact-btn mb-3"
                              >
                                <i className="fa-solid fa-envelope contact"></i>{" "}
                                Contact Us
                              </Link>
                              <Link
                                to={`/location/${palmdata.slug}`}
                                className="btn contact-us-btn  contact-btn location-btn  mb-3"
                              >
                                <i className="fa-solid fa-location-dot"></i>
                                Locations
                              </Link>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>

                <div
                  id="collapseThree"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {loading && (
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
            <PageLoading color={"var(--metro-yellow)"} classes={"justify-content-center"} />
          </div>
        </div>
      )}
    </>
  );
};

export default PalmBeachCounty;
